import getObjectValues from "../../../../utils/getObjectValues";
import { LoginErrors } from "./errors";

const LoginTranslationsDictionary = {
    LoginTitle: "Log in",
    AddCoDriverTitle: "Add Co-Driver",
    Username: "Username",
    Database: "Database",
    Server: "Server",
    ServerPlaceholder: "Server (Optional)",
    Password: "Password",
    Next: "Next",
    Advanced: "Advanced",
    Error: "Error",

    // Exessive users
    MaximumNumberOfUsersLoggedIn: "Maximum number of users logged in at once reached ({0}). Select the users whose sessions you want to end.",
    LoggedInSince: "Logged in since {0}",
    SelectedSessionsEnded: "Selected sessions ended",

    // Login spinner status messages
    LoggingIn: "Logging in...",
    LoggingInAs: "Logging in as {0}...",
    Cancel: "Cancel",

    // Update password prompt
    PasswordUpdateRecommended: "Password update recommended",
    PasswordUpdateRecommendedMessage: "Your current password doesn't meet your database's policy. Update it now; you'll be required to change it later.",
    RemindMeLater: "Remind me later",
    UpdatePassword: "Update password",

    // Update password page
    UpdateYourPassword: "Update your password",
    UpdatePasswordButton: "Update Password",
    ConfirmPassword: "Confirm password",
    PasswordMust: "Password must",
    PasswordMinimumLength: "Be at least {0} characters long",
    PasswordUpperCase: "Contain uppercase letters (minimum {0})",
    PasswordLowerCase: "Contain lowercase letters (minimum {0})",
    PasswordNumbers: "Contain numbers (minimum {0})",
    PasswordSpecialCharacters: "Contain special characters (minimum {0})",
    PasswordNotUserName: "Not contain your username",
    PasswordNotCommon: "Not common or easy to guess (e.g., 112233 or qwerty)",
    PasswordRequired: "Password is required.",
    PasswordsDoNotMatch: "Passwords do not match.",
    ShowPassword: "Show password",
    HidePassword: "Hide password",
    RequestNotCompleted: "Request not completed",
    TooManyRequests: "Too many requests received. Please try again in a few minutes.",
    CommonPasswordsNotAllowed: "Common passwords are not allowed.",
    PasswordTooWeak: "Password is too weak.",
    PasswordRecentlyUsed: "Password has been recently used.",
    PasswordContainsUserName: "Password contains username information.",
    PasswordDoesNotMeetPolicy: "Password does not meet the password policy requirements.",
    NewPassword: "New password",
    RequirementMet: "Requirement met",
    RequirementNotMet: "Requirement not met",
    PasswordUpdated: "Password updated",
    PasswordUpdatedMessage: "Your password has been successfully updated.",
    GoToApplication: "Go to application",

    // QR sign-in panel
    QrSignInWithQrCode: "Sign in with a QR code",
    QrRequesting: "Requesting a sign-in code...",
    QrScanInstruction: "Scan the QR code with your phone to sign in.",
    QrSigningIn: "Signing in...",
    QrImageAlt: "Sign-in QR code",
    QrUnavailable: "QR sign-in isn't available here. Sign in with your username.",
    QrExpired: "The QR code expired. Please try again.",
    QrNetworkError: "We could not reach the sign-in service. Please try again.",
    QrDenied: "The sign-in request was denied on your phone.",
    QrFailed: "QR sign-in failed. Please try again.",
    QrTryAgain: "Try again",

    // Login error messages
    ...LoginErrors
};

export const LoginTranslations = getObjectValues(LoginTranslationsDictionary);
export default LoginTranslationsDictionary;